import { apiInstance } from "shared/api";
import { ApiActsResponse, PayoutResponse } from "./types";

export const getTransactionsForRefund = (): Promise<ApiActsResponse> => {
  return apiInstance
    .get(`/v1/return-transactions`)
    .then((response) => response.data);
};
export const transactionsPayout = (id: string): Promise<PayoutResponse> => {
  return apiInstance
    .post(`/v1/return-transactions/${id}/payout`)
    .then((response) => response.data);
};
